/* repo/terminal */
import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { TerminalCodec, Terminal, Data } from "../store/terminal/types";
import { withDecoded, flattenData } from "./";

const TERMINAL = "terminal";
const TERMINAL_UPLOAD = "terminalimport";

function mapToModel(data: object): Terminal {
  return data as any;
}

function mapToChangeset(processor: Data): Data {
  return processor;
}

export async function fetch(id: string | null, params?: {}): Promise<Terminal> {
  return fetchApi({
    nestedResourcePath: [TERMINAL],
    id: id,
    params: params,
  }).then((response) => {
    return mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    );
  });
}

export async function save(processor: Data): Promise<Terminal> {
  return insertApi({
    nestedResourcePath: [TERMINAL],
    id: processor.id,
    data: { data: mapToChangeset(processor) },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: [TERMINAL],
    id: id,
  }).then(() => true);
}

export async function upload(data: string): Promise<any> {
  return insertApi({
    nestedResourcePath: [TERMINAL_UPLOAD],
    id: undefined,
    data,
  }).then((response) => {
    return response.data;
  });
}
